import React from "react";
import { Box, CircularProgress } from "@mui/joy";

const LoadingState: React.FC = () => {
  return (
    <Box sx={{ 
      minHeight: "100vh", 
      bgcolor: "#f4f4f4",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}>
      <CircularProgress size="lg" />
    </Box>
  );
};

export default LoadingState; 